export const URL_SEARCH_TEACHER = 'teacher';
export const URL_SEARCH_STUDENT = 'student';
